/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export * from "./CosmosPageHeroAndSections.data";
export * from "./CosmosPageHeroAndSections.page";
